import Swal from 'sweetalert2'

$(document).ready(function() {
    const companiesModule = {
        isLoading: false,
        init() {
            $(document).on('click', '#add-new-company', this, this.addNewCompany);
			$(document).on('click', '#save-new-company', this, this.saveCompany);
            $(document).on('click', '#cancel-new-company', this, function() {
				$('#new-company-form-wrapper').hide();
			});

            $(document).on('click', '.edit-company', this, this.editCompany);
            $(document).on('click', '.cancel-edit-company', this, function() {
				var id = $(this).data('id');
				
				$('#company-' +id).find('.form-control').attr('disabled', true);
				$('#company-' +id).find('.edit-company').show();
				$('#company-' +id).find('.save-company').hide();
				$('#company-' +id).find('.cancel-edit-company').hide();
				
				$('#company-' +id).find('.edit-countries-select').select2({
					disabled: true
				});
				$('#company-' +id).find('.edit-states-select').select2({
					disabled: true
				});
				$('#company-' +id).find('.edit-cities-select').select2({
					disabled: true
				});
			});
            $(document).on('click', '.save-company', this, this.updateCompany);
            
			$(document).on('click', '.delete-company', this, this.deleteCompany);

			$('.edit-countries-select').select2({
				disabled: true
			});
			$('.edit-states-select').select2({
				disabled: true
			});
			$('.edit-cities-select').select2({
				disabled: true
			});

			$(document).on('change', '#country_id', this, this.getStates);
			$(document).on('change', '#state_id', this, this.getCities);
			$(document).on('change', '.edit-countries-select', this, this.getStates);
			$(document).on('change', '.edit-states-select', this, this.getCities);
        },
		editCompany(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }
			var element = this;

			$('#company-' +id).find('.form-control').removeAttr('disabled');
			$('#company-' +id).find('.edit-company').hide();
			$('#company-' +id).find('.save-company').show();
			$('#company-' +id).find('.cancel-edit-company').show();
			
			$('#company-' +id).find('.edit-countries-select').select2({
				disabled: false
			});
			$('#company-' +id).find('.edit-states-select').select2({
				disabled: false
			});
			$('#company-' +id).find('.edit-cities-select').select2({
				disabled: false
			});

			//get states
			var stateId = $('#state_id_'+id+' option:selected').val();
			var stateElementName = '#state_id_' + id;
			$(stateElementName).find('option:not(:first)').remove();
			
			_this.isLoading = true;
			$(element).find('i').show();

			$.ajax({
                type: "GET",
                url: baseURL + "/account/states/" + $('#country_id_'+id+' option:selected').val(),
                // data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').hide();

					let states = Object.keys(response).map(key => {
						return response[key];
					});

					for (var i in states) {
						$(stateElementName).append('<option value="'+states[i].id+'" '+(stateId == states[i].id ? 'selected="selected"' : '')+'>'+states[i].name+'</option>');
					}
                },
                error: function() {
                    _this.isLoading = false;
                    $(element).find('i').hide();
                }
            });
			//get states

			//get cities
			var cityId = $('#city_id_'+id+' option:selected').val();
			var cityElementName = '#city_id_' + id;
			$(cityElementName).find('option:not(:first)').remove();

			_this.isLoading = true;
			$(element).find('i').show();

			$.ajax({
                type: "GET",
                url: baseURL + "/account/cities/" + stateId,
                // data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').hide();

					let cities = Object.keys(response).map(key => {
						return response[key];
					});

					for (var i in cities) {
						$(cityElementName).append('<option value="'+cities[i].id+'" '+(cityId == cities[i].id ? 'selected="selected"' : '')+'>'+cities[i].name+'</option>');
					}
                },
                error: function() {
                    _this.isLoading = false;
                    $(element).find('i').hide();
                }
            });
			//get cities
		},
		updateCompany(event) {
            const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }
			var element = this;

            if (_this.isLoading) {
                return false;
            }

            $('#company-' + id).find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#name_' + id).val() == '') {
				$('#name_' + id).addClass('is-invalid');
				errors = true;
			}
			if ($('#trade_register_number_' + id).val() == '') {
				$('#trade_register_number_' + id).addClass('is-invalid');
				errors = true;
			}
			if ($('#unique_registration_code_' + id).val() == '') {
				$('#unique_registration_code_' + id).addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoading = true;
			$(element).find('i').show();

			var values = '_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
            values += '&name=' + encodeURIComponent($('#name_'+id).val());
            values += '&trade_register_number=' + encodeURIComponent($('#trade_register_number_'+id).val());
            values += '&unique_registration_code=' + encodeURIComponent($('#unique_registration_code_'+id).val());
            values += '&country_id=' + encodeURIComponent($('#country_id_'+id+' option:selected').val());
            values += '&state_id=' + encodeURIComponent($('#state_id_'+id+' option:selected').val());
            values += '&city_id=' + encodeURIComponent($('#city_id_'+id+' option:selected').val());
            values += '&address=' + encodeURIComponent($('#address_'+id).val());
            values += '&bank_name=' + encodeURIComponent($('#bank_name_'+id).val());
            values += '&bank_account=' + encodeURIComponent($('#bank_account_'+id).val());

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/companies/${id}/edit`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
					$(element).find('i').show();
                },
                complete: function() {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
                success: function(response, xhr) {
                    _this.isLoading = false;
					$(element).find('i').hide();

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey+'_'+id).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {

						$('#company-' +id).find('.form-control').prop('disabled', true);
						$('#company-' +id).find('.save-company').hide();
						$('#company-' +id).find('.cancel-edit-company').hide();
						$('#company-' +id).find('.edit-company').show();
						$('#company-' +id).find('.company-name').html(response.data.name);
						$('.edit-countries-select').select2({
							disabled: true
						});
						$('.edit-states-select').select2({
							disabled: true
						});
						$('.edit-cities-select').select2({
							disabled: true
						});

						Swal.fire({
							text: response.message
						});

						return;
                    }

					Swal.fire({
						text: response.message
					});
                },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
            });
        },
        deleteCompany(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

			Swal.fire({
				title: $('#companies-container').data('delete-title'),
				text: $('#companies-container').data('delete-text'),
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#dd2121',
				cancelButtonColor: '#bbb',
				confirmButtonText: $('#companies-container').data('delete-btn-yes'),
				cancelButtonText: $('#companies-container').data('delete-btn-no')
			}).then((result) => {

				if (!result.isConfirmed) {
					return false;
				}

				if (_this.isLoading) {
	                return false;
	            }

				//Loading...
	            _this.isLoading = true;

	            $.ajax({
	                type: "GET",
	                url: `${baseURL}/account/companies/${id}/delete`,
	                // data: values,
	                beforeSend: function() {
	                    _this.isLoading = true;
	                },
	                complete: function() {
	                    _this.isLoading = false;
	                },
	                success: function(response, xhr) {
	                    _this.isLoading = false;

	                    if (response.status == 1) {
							$('#company-' + id).remove();
							Swal.fire(
								// $('#companies-container').data('delete-success-title'),
								$('#companies-container').data('delete-success-text'),
								// 'success'
		    				);

							if ($('#companies-container').children().length == 0){
								$('#companies-container').html('<p class="empty">'+$('#companies-container').data('empty-text')+'</p>');
							} else {
								//console.log('is not epmtpy');
							}

							return;
	                    }
	                },
	                error(error) {
	                    _this.isLoading = false;
	                },
	            });

  				//if (result.value) {}
			});
		},
        addNewCompany(event) {
			const _this = event.data;

			$('#new-company-form-wrapper').show();

			$('.countries-select').select2();
			$('.cities-select').select2();
			$('.states-select').select2();
		},
        saveCompany(event) {
            const _this = event.data;
			var element = this;

            if (_this.isLoading) {
                return false;
            }

            $('.form-new-company').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#name').val() == '') {
				$('#name').addClass('is-invalid');
				errors = true;
			}
			if ($('#trade_register_number').val() == '') {
				$('#trade_register_number').addClass('is-invalid');
				errors = true;
			}
			if ($('#unique_registration_code').val() == '') {
				$('#unique_registration_code').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoading = true;
			$(element).find('i').show();

            var values = '_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
            values += '&name=' + encodeURIComponent($('#name').val());
            values += '&trade_register_number=' + encodeURIComponent($('#trade_register_number').val());
            values += '&unique_registration_code=' + encodeURIComponent($('#unique_registration_code').val());
            values += '&country_id=' + encodeURIComponent($('#country_id option:selected').val());
            values += '&state_id=' + encodeURIComponent($('#state_id option:selected').val());
            values += '&city_id=' + encodeURIComponent($('#city_id option:selected').val());
            values += '&address=' + encodeURIComponent($('#address').val());
            values += '&bank_name=' + encodeURIComponent($('#bank_name').val());
            values += '&bank_account=' + encodeURIComponent($('#bank_account').val());

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/companies/create`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
					$(element).find('i').show();
                },
                complete: function() {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
                success: function(response, xhr) {
                    _this.isLoading = false;
					$(element).find('i').hide();

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {

						$('#companies-container').prepend(response.html);

						$('#new-company-form-wrapper').hide();
						$('.form-new-company').find('.form-control').val('');
						$('#state_id').find('option:not(:first)').remove();
						$('#city_id').find('option:not(:first)').remove();

						$('.edit-countries-select').select2({
							disabled: true
						});
						$('.edit-states-select').select2({
							disabled: true
						});
						$('.edit-cities-select').select2({
							disabled: true
						});

						Swal.fire({
							text: response.message
						});

						return;
                    }

					Swal.fire({
						text: response.message
					});
                },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
            });
        },
		getStates(event) {
			const _this = event.data;
			event.preventDefault();
            var element = this;
			var idElement = $(this).attr('id');

			var stateElementName = '#'+$(this).data('field');//'#state_id';
			$(stateElementName).find('option:not(:first)').remove();

			var cityElementName = '#'+$(this).data('city-field');//'#city_id';
			$(cityElementName).find('option:not(:first)').remove();


			if ($('#'+idElement+' option:selected').val() == '') {
				_this.isLoading = false;
				$(idElement).siblings().find('i').hide();
				return;
			}

			//Loading...
            _this.isLoading = true;
			$(idElement).siblings().find('i').show();

			$.ajax({
                type: "GET",
                url: baseURL + "/account/states/" + $('#'+idElement+' option:selected').val(),
                // data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(idElement).siblings().find('i').hide();

					let states = Object.keys(response).map(key => {
						return response[key];
					});

					for (var i in states) {
						$(stateElementName).append('<option value="'+states[i].id+'">'+states[i].name+'</option>');
					}
                },
                error: function() {
                    _this.isLoading = false;
                    $(idElement).siblings().find('i').hide();
                }
            });
        },
		getCities(event) {
			const _this = event.data;
			event.preventDefault();
            var element = this;
			var idElement = $(this).attr('id');
			var cityElementName = '#'+$(this).data('field');//'#city_id';

			$(cityElementName).find('option:not(:first)').remove();

			if ($('#'+idElement+' option:selected').val() == '') {
				_this.isLoading = false;
				$(idElement).siblings().find('i').hide();
				return;
			}

			//Loading...
            _this.isLoading = true;
			$(idElement).siblings().find('i').show();

			$.ajax({
                type: "GET",
                url: baseURL + "/account/cities/" + $('#'+idElement+' option:selected').val(),
                // data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(idElement).siblings().find('i').hide();

					let cities = Object.keys(response).map(key => {
						return response[key];
					});

					for (var i in cities) {
						$(cityElementName).append('<option value="'+cities[i].id+'">'+cities[i].name+'</option>');
					}
                },
                error: function() {
                    _this.isLoading = false;
                    $(idElement).siblings().find('i').hide();
                }
            });
        },
    };

    if ($('#account-companies').length) {
        companiesModule.init();
    }
});
